<template>
  <div class="color-page">
    <ExpansionCard title="Frame en dakbeschot">
      <ColorSelectorPreview :options="sortedFrameColors" :selected="selectedFrameColor" class="color-page-preview" @change="updateFrameTexture" />
    </ExpansionCard>

    <ExpansionCard title="Boeidelen" v-if="afmetingen.boeideel.enabled && afmetingen.wall.position !== 'buiten'">
      <ColorSelectorPreview :options="afmetingen.omlijstingPalen ? sortedFrameColors : sortedBoardColors" :selected="selectedBoardColors" class="color-page-preview" @change="updateBoardTexture"  />
    </ExpansionCard>

    <ExpansionCard title="Hoekprofielen" v-if="afmetingen.wall.position === 'buiten'">
      <ColorSelectorPreview :options="sortedHoekprofielColors" :selected="selectedHoekprofielColor" class="color-page-preview" @change="updateHoekprofielTexture"  />
    </ExpansionCard>

    <ExpansionCard title="Trim" v-if="config.typeId === '629a060f2fbe252c87361bdc' || config.typeId === '629a060f2fbe252c87361be0'">
      <ColorSelectorPreview :options="textures.filter(color => selectedSize.trim.color.includes(color.id))" :selected="selectedTrimColor" class="color-page-preview" @change="updateTrimColor"  />
    </ExpansionCard>
  </div>
</template>

<script>
  import ColorSelectorPreview from '@/components/inputs/ColorSelectorPreview.vue'
  import ExpansionCard from '@/components/layout/ExpansionCard.vue'
   import { mapGetters } from 'vuex'

  export default {
    components: {
      ColorSelectorPreview,
      ExpansionCard
    },

    data () {
      return {
  customOrder: ['Onbehandeld', 'Douglas transp.', 'Zwart RAL9005', 'Ebben bruin/zwart', 'Wit RAL9010', 'Grijs RAL7016', 'Ayous' , 'Vuren' ] // Define your custom order here
      }
    },

    methods: {
      // Case-insensitive index lookup; unknown items go to the end
      orderIndex(name) {
        const target = String(name || '').toLowerCase()
        const idx = this.customOrder.findIndex(n => String(n).toLowerCase() === target)
        return idx === -1 ? Number.POSITIVE_INFINITY : idx
      },

      updateFrameTexture(color, canChangeOther) {
        this.$store.dispatch('updateFrameTexture', color)
        if(this.afmetingen.omlijstingPalen && !canChangeOther) {
          this.updateBoardTexture(color, true)
        }
        // console.log(this.afmetingen)
      },

      updateBoardTexture (color, canChangeOther) {
        this.$store.dispatch('updateBoeideelTexture', color)
        if(this.afmetingen.omlijstingPalen && !canChangeOther) {
          this.updateFrameTexture(color, true)
        }
      },

      updateHoekprofielTexture (color) {
        this.$store.dispatch('updateHoekprofielTexture', color)
      },

      updateTrimColor (color) {
        this.$store.dispatch('updateTrimColor', color)
      }
    },

    computed: {
      ...mapGetters({
        selectedFrameColor: 'getSelectedFrameColor',
        frameColors: 'getFrameColors',
        selectedBoardColors: 'getSelectedBoeideelColor',
        boardColors: 'getBoeideelColors',
        selectedHoekprofielColor: 'getSelectedHoekprofielColor',
        hoekprofielcolors: 'getHoekprofielColors',
        menuColors: 'getMenuColors',
        textures: 'getTextures',
        selectedSize: 'getSelectedSizes',
        selectedTrimColor: 'getSelectedTrimColor',
        afmetingen: 'getSelectedSizes',
        config: 'getConfig'
      }),

      sortedFrameColors() {
        return this.frameColors.slice().sort((a, b) => {
          return this.customOrder.indexOf(a.name) - this.customOrder.indexOf(b.name);
        });
      },

      sortedBoardColors() {
        return this.boardColors.slice().sort((a, b) => {
          return this.customOrder.indexOf(a.name) - this.customOrder.indexOf(b.name);
        });
      },

      sortedHoekprofielColors() {
        return this.hoekprofielcolors.slice().sort((a, b) => {
          const ai = this.orderIndex(a.name)
          const bi = this.orderIndex(b.name)
          if (ai === bi) return 0
          return ai - bi
        })
      },
    },

    created () {
      this.$store.dispatch('getWallColors')
    }
  }
</script>

<style lang="scss" scoped>

.color-page {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.color-page-preview {
  padding-bottom: 8px;
}

</style>